import { intlLocale } from '@/i18n/constants';
import { percentToBp } from '@/i18n/format';

/** Stored bp as a grouping-free percent string for a TextField. */
export function bpToPercentInput(bp: number, locale: string): string {
  return new Intl.NumberFormat(intlLocale(locale), {
    maximumFractionDigits: 2,
    useGrouping: false,
  }).format(bp / 100);
}

export function parsePercentInput(value: string, locale: string): number | null {
  return percentToBp(value, locale);
}
